import React, { useEffect, useState } from 'react';
import { getStoredConsent, setConsent } from '@app/lib/analytics';
import { useLang } from '@app/lib/useLang';
import styles from './style.module.css';

// Тексты — те же, что в баннере приложения (play.algarve-quest.com).
const STRINGS = {
  en: { text: 'We use cookies to measure traffic and improve your experience.', accept: 'Accept', decline: 'Decline' },
  pt: { text: 'Utilizamos cookies para medir o tráfego e melhorar a sua experiência.', accept: 'Aceitar', decline: 'Recusar' },
  ru: { text: 'Мы используем куки, чтобы измерять трафик и улучшать сервис.', accept: 'Принять', decline: 'Отклонить' },
};

const ConsentBanner: React.FC = () => {
  const lang = useLang();
  // Показываем только после гидратации: в пререндеренном HTML баннера нет.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getStoredConsent() === null);
  }, []);

  if (!visible) return null;

  const L = STRINGS[lang];
  const choose = (granted: boolean) => () => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <div role="dialog" aria-label="Cookie consent" className={styles.banner}>
      <span>{L.text}</span>
      <div className={styles.actions}>
        <button type="button" onClick={choose(false)} className={styles.decline}>
          {L.decline}
        </button>
        <button type="button" onClick={choose(true)} className={styles.accept}>
          {L.accept}
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
